import * as React from 'react';
import { cn } from '@/lib/utils';

interface CurrencySelectorProps {
  value: string;
  onChange: (currency: string) => void;
  currencies: string[];
  className?: string;
}

export function CurrencySelector({
  value,
  onChange,
  currencies,
  className,
}: CurrencySelectorProps) {
  const [showDropdown, setShowDropdown] = React.useState(false);
  const dropdownRef = React.useRef<HTMLDivElement>(null);

  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [showDropdown]);

  return (
    <div className={cn('relative', className)} ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setShowDropdown(!showDropdown)}
        className="text-xl font-semibold text-muted-foreground hover:text-foreground underline decoration-dashed hover:decoration-solid transition-colors cursor-pointer px-3 py-2"
      >
        {value}
      </button>
      
      {/* Currency dropdown */}
      {showDropdown && (
        <div className="absolute top-full right-0 mt-2 bg-background border border-input rounded-lg shadow-lg z-10 min-w-[150px] max-h-[300px] overflow-y-auto">
          {currencies.map((currency) => (
            <button
              key={currency}
              type="button"
              onClick={() => {
                onChange(currency);
                setShowDropdown(false);
              }}
              className={cn(
                'w-full text-left px-3 py-2 hover:bg-muted text-sm transition-colors first:rounded-t-lg last:rounded-b-lg',
                currency === value && 'bg-muted font-medium'
              )}
            >
              {currency}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
